// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(milestone) {
  switch (milestone) {
    case "Bronze Hero" :
        return /* BronzeHero */1;
    case "Bronze Super Star" :
        return /* BronzeSuperStar */2;
    case "Diamond Hero" :
        return /* DiamondHero */9;
    case "Diamond Super Star" :
        return /* DiamondSuperStar */10;
    case "Gold Hero" :
        return /* GoldHero */7;
    case "Gold Super Star" :
        return /* GoldSuperStar */8;
    case "Platinum Hero" :
        return /* PlatinumHero */5;
    case "Platinum Super Star" :
        return /* PlatinumSuperStar */6;
    case "Porter Hero" :
        return /* PorterHero */11;
    case "Silver Hero" :
        return /* SilverHero */3;
    case "Silver Super Star" :
        return /* SilverSuperStar */4;
    case "Star" :
        return /* Star */0;
    case "Supro Super Star" :
        return /* SuproSuperStar */12;
    default:
      return ErrorUtils$Catalyst.raiseError("RewardMilestone.fromString", "Unexpected milestone received", milestone);
  }
}

function toString(milestone) {
  switch (milestone) {
    case /* Star */0 :
        return "Star";
    case /* BronzeHero */1 :
        return "Bronze Hero";
    case /* BronzeSuperStar */2 :
        return "Bronze Super Star";
    case /* SilverHero */3 :
        return "Silver Hero";
    case /* SilverSuperStar */4 :
        return "Silver Super Star";
    case /* PlatinumHero */5 :
        return "Platinum Hero";
    case /* PlatinumSuperStar */6 :
        return "Platinum Super Star";
    case /* GoldHero */7 :
        return "Gold Hero";
    case /* GoldSuperStar */8 :
        return "Gold Super Star";
    case /* DiamondHero */9 :
        return "Diamond Hero";
    case /* DiamondSuperStar */10 :
        return "Diamond Super Star";
    case /* PorterHero */11 :
        return "Porter Hero";
    case /* SuproSuperStar */12 :
        return "Supro Super Star";
    
  }
}

function toMultilangString(milestone, content) {
  switch (milestone) {
    case /* Star */0 :
        return content.milestoneDetails.milestone1;
    case /* BronzeHero */1 :
        return content.milestoneDetails.milestone2;
    case /* BronzeSuperStar */2 :
        return content.milestoneDetails.milestone3;
    case /* SilverHero */3 :
        return content.milestoneDetails.milestone4;
    case /* SilverSuperStar */4 :
        return content.milestoneDetails.milestone5;
    case /* PlatinumHero */5 :
        return content.milestoneDetails.milestone6;
    case /* PlatinumSuperStar */6 :
        return content.milestoneDetails.milestone7;
    case /* GoldHero */7 :
        return content.milestoneDetails.milestone8;
    case /* GoldSuperStar */8 :
        return content.milestoneDetails.milestone9;
    case /* DiamondHero */9 :
        return content.milestoneDetails.milestone10;
    case /* DiamondSuperStar */10 :
        return content.milestoneDetails.milestone11;
    case /* PorterHero */11 :
        return content.milestoneDetails.milestone12;
    case /* SuproSuperStar */12 :
        return content.milestoneDetails.milestone13;
    
  }
}

function fromUrlString(milestone) {
  switch (milestone) {
    case "Bronze_Hero" :
        return /* BronzeHero */1;
    case "Bronze_Super_Star" :
        return /* BronzeSuperStar */2;
    case "Diamond_Hero" :
        return /* DiamondHero */9;
    case "Diamond_Super_Star" :
        return /* DiamondSuperStar */10;
    case "Gold_Hero" :
        return /* GoldHero */7;
    case "Gold_Super_Star" :
        return /* GoldSuperStar */8;
    case "Platinum_Hero" :
        return /* PlatinumHero */5;
    case "Platinum_Super_Star" :
        return /* PlatinumSuperStar */6;
    case "Porter_Hero" :
        return /* PorterHero */11;
    case "Silver_Hero" :
        return /* SilverHero */3;
    case "Silver_Super_Star" :
        return /* SilverSuperStar */4;
    case "Star" :
        return /* Star */0;
    case "Supro_Super_Star" :
        return /* SuproSuperStar */12;
    default:
      return ErrorUtils$Catalyst.raiseError("RewardMilestone.fromUrlString", "Unacceptable milestone found", milestone);
  }
}

function toUrlString(milestone) {
  switch (milestone) {
    case /* Star */0 :
        return "Star";
    case /* BronzeHero */1 :
        return "Bronze_Hero";
    case /* BronzeSuperStar */2 :
        return "Bronze_Super_Star";
    case /* SilverHero */3 :
        return "Silver_Hero";
    case /* SilverSuperStar */4 :
        return "Silver_Super_Star";
    case /* PlatinumHero */5 :
        return "Platinum_Hero";
    case /* PlatinumSuperStar */6 :
        return "Platinum_Super_Star";
    case /* GoldHero */7 :
        return "Gold_Hero";
    case /* GoldSuperStar */8 :
        return "Gold_Super_Star";
    case /* DiamondHero */9 :
        return "Diamond_Hero";
    case /* DiamondSuperStar */10 :
        return "Diamond_Super_Star";
    case /* PorterHero */11 :
        return "Porter_Hero";
    case /* SuproSuperStar */12 :
        return "Supro_Super_Star";
    
  }
}

export {
  fromString ,
  toString ,
  toMultilangString ,
  fromUrlString ,
  toUrlString ,
  
}
/* No side effect */
